import { UnifiedFile } from ".";

export type ActiveStorageFileType = {
  signed_id: string;
  name: string;
  url: string;
  is_image: boolean;
};

export class ActiveStorageFile implements UnifiedFile {
  #value: ActiveStorageFileType;

  constructor(file: ActiveStorageFileType) {
    this.#value = file;
  }

  get url() {
    return this.#value.url;
  }

  upload() {
    return Promise.resolve({
      uploadedFile: this,
    });
  }

  get signedId() {
    return this.#value.signed_id;
  }

  get size() {
    return -1 as const;
  }

  get isNull() {
    return false;
  }

  get value() {
    return this.#value;
  }
}

